import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import Acesso from '@/pages/Acesso'
import Contrato from '@/pages/Contrato/Contrato'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Acesso',
      component: Acesso
    },
    {
      path: '/contrato',
      name: 'Contrato',
      component: Contrato,
      meta: { requiresAuth: true }
    }
  ]
})

// Guard de navegação - proteger rotas que requerem autenticação
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'Acesso' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js